<div class="relative flex items-center gap-x-3 md:w-full">
  <div class="relative flex-1">
    <label for="search" class="block relative rounded-full shadow-sm">
      <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
        <ng-icon name="heroMagnifyingGlass" size="1.5rem" strokeWidth="1"></ng-icon>
      </div>
      <input type="text" name="search" id="search" data-search-bar autocomplete="off"
             (focus)="focus()" (blur)="blur()" (input)="onSearch()" (keydown)="keyDown()"
             [(ngModel)]="searchText"
             class="block w-full rounded-full border-0 py-2.5 pl-10 text-gray-900 placeholder:text-gray-400 placeholder:font-light placeholder:italic focus:ring-1 focus:ring-gray-400 text-sm"
             placeholder="Wat gaan we doen?">
    </label>
    @if (showDropdown) {
      <ul
        class="absolute z-10 mt-1 max-h-80 md:max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm"
        id="options" role="listbox">
        @for (pointOfInterest of filteredPointOfInterests; track $index) {
          <li>
            <button (mousedown)="setSelectedPointOfInterest(pointOfInterest)"
                    class="relative w-full text-left py-2 pl-3 pr-9 text-gray-900 hover:bg-secondary-100 hover:outline-none">
            <span class="flex items-center gap-x-2">
              <span class="size-6 flex items-center justify-center">
                @if (pointOfInterest.isStory) {
                  <app-base64-svg [base64]="pointOfInterest.categories[0].icon"
                                  [color]="pointOfInterest.categories[0].color"></app-base64-svg>
                } @else {
                  <ng-icon name="heroMapPinSolid" strokeWidth="3" [size]="'1.25rem'" class="text-[#00B5E5]"></ng-icon>
                }
              </span>
              <span class="list-item-poi truncate flex gap-2 items-center"
                    [ngClass]="{'font-semibold': selected.id === pointOfInterest.id && selected.isStory && pointOfInterest.isStory}">
                {{ pointOfInterest.title }}
              </span>
            </span>

              @if (selected.id === pointOfInterest.id && selected.isStory && pointOfInterest.isStory) {
                <span class="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600">
              <svg class="size-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                <path fill-rule="evenodd"
                      d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                      clip-rule="evenodd"/>
              </svg>
            </span>
              }
            </button>
          </li>
        } @empty {
          <em class="pl-3">Geen resultaten gevonden</em>
        }
      </ul>
    }
  </div>
</div>
